<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Uq3O0j/tc-custom/9780830825486.jpg?1696870362788" alt="This image is the cover for the book Commentaries on Job, Hosea, Joel, and Amos, Ancient Christian Texts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Commentaries on Job, Hosea, Joel, and Amos, Ancient Christian Texts
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>"Then the Lord answered Job out of the whirlwind . . . "</strong> </p> <p>Julian of Eclanum (c. 386–455) was the bishop of Eclanum, located in modern-day Italy. In this volume in IVP's Ancient Christian Texts series, Thomas Scheck provides a new translation of Julian's commentaries on the biblical books of Job and those of three Minor Prophets: Hosea, Joel, and Amos. Here, readers will gain insight into how early Christians read texts such as God's speech to Job, Hosea's symbolic representation of God's unending love for a faithless Israel, Joel's anticipation of the outpouring of the Holy Spirit, and Amos's call for social justice.</p> <p>While Julian was a well-known leader among the Pelagians, whose theology was famously opposed by Augustine of Hippo and ultimately determined to be outside the bounds of the church's orthodoxy, the Pelagian movement was a significant element within the early church. And although Julian's Pelagianism does not fundamentally affect the commentaries presented in this volume, Christians can gain insight into the truths of Scripture by reading the text alongside others, even when—or perhaps especially when—we might disagree with other aspects of their beliefs.</p> <p>Ancient Christian Texts are new English translations of full-length commentaries or sermon series from ancient Christian authors that allow you to study key writings of the early church fathers in a fresh way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julian of Eclanum, Thomas P. Scheck
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25c31d90